import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as SsoActions from '../actions/sso.actions';
import { SsoService } from '../services/sso.service';

@Injectable()
export class SsoEffects {
    constructor(private actions$: Actions, private http: HttpClient, private ssoServices: SsoService) {}

    loadSsoProviders$ = createEffect(() =>
        this.actions$.pipe(
            ofType(SsoActions.loadSsoProvider.type),
            mergeMap((action: { handle: string }) => {
                return this.ssoServices.getSsoProvider(action.handle).pipe(
                    map((response) => {
                        return SsoActions.loadSsoProviderSuccess({ provider: response });
                    }),
                    catchError((error) => {
                        console.error('[Aumico-SsoProvider] Load SSO Provider Failure', error);
                        return of(SsoActions.loadSsoProviderFailure({ error }));
                    }),
                );
            }),
        ),
    );
}
